'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import UIButtonGroup from 'UIComponents/button/UIButtonGroup';
export default function Toolbar(props) {
  return /*#__PURE__*/_jsx(UIButtonGroup, Object.assign({
    orientation: "vertical"
  }, props));
}